module.exports = function(options) {

    return {
        ...options,

        // Overwrite options
        language: 'nl',

        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: { 'class': '' } },

            { name: 'Primaire knop', element: 'a', attributes: {'class': 'btn-primary'} },
            { name: 'Secondaire knop', element: 'a', attributes: {'class': 'btn-secondary'} },
        ],

    };

};
